export default __webpack_public_path__ + "static/chatons-a8148572e24eaaf0294fbe52cb7e5d2e.svg";